import React from "react"
import cardHOC from "./carHOC"
import studentBPicture from "../../images/trainingPartners/student 1.png"

const LXPHeading: React.FC<{ active: boolean }> = (props) => {
  return (
    <h4
      style={{
        textAlign: "center",
        color: props.active ? "#1E53D9" : "#092C4C",
      }}
    >
      Licence the Dacreed platform
    </h4>
  )
}

const LXPCardTemplate = cardHOC(LXPHeading)

const LXPCard: React.FC<{ className: string }> = (props) => {
  return (
    <LXPCardTemplate
      heading="Enterprise licencing available to self host"
      imgSrc={studentBPicture}
      content="Licence our Learning Experience Platform (LXP) for your own solution"
      className={props.className}
      activeColor="#1E53D9"
      path="/about-learning-platform"
      linkLabel="More about the Dacreed Platform"
    />
  )
}

export default LXPCard
